import request from './public'

// 登陆
export const userLogin = (params) => {
  return request.post('/user.login', params)
}
// 手机验证码登录
export const smsLogin = (params) => {
  return request.post('/user.smslogin', params)
}
// 重置密码
export const updatePawd = (params) => {
  return request.post('/updatePassword', params)
}

// 退出登陆
export const loginOut = (params) => {
  return request.post('/user.logout', params)
}
// 用户信息
export const userInfo = (params) => {
  return request.post('/user.info', params)
}
// 检查手机号是否注册
export const checkPhone = (params) => {
  return request.post('/user.checkphone', params)
}
// 获取手机短信验证码，并且发送短信（通过传递指定类型的短信模板来控制）
export const userSms = (params) => {
  return request.post('/user.sms', params)
}

// 验证手机验证码
export const regCheckCms = (params) => {
  return request.post('/user.check_sms', params)
}

// 注册账号
export const register = (params) => {
  return request.post('/api/member/reg.info', params)
}
// 验证图形验证码
export const checkCaptcha = (params) => {
  return request.post('/api/member/check_captcha', params)
}
export const regCaptcha = (params) => {
  return request.post('/api/member/reg.captcha', params)
}
// 注册，验证图形验证码
export const regCheckCaptcha = (params) => {
  return request.post('/api/member/reg.check_captcha', params)
}
// 商城标签
export const memberTagList = (params) => {
  return request.post('/api/memberTag/list', params)
}

// 上传图片
export const upload = (params) => {
  return request.post('/api/upload', params)
}
// 修改头像
export const updateheadimage = (params) => {
  return request.post('/user.editinfo', params)
}
// 捐赠列表
export const thanksList = (params) => {
  return request.post('/api/member/thanks', params)
}
// 首页接口
export const productHome = (params) => {
  return request.post('/pc.getpageconfig', params)
}
// 首页接口
export const navList = (params) => {
  return request.post('/home.navlist', params)
}
// 推荐板块
export const recommend = (params) => {
  return request.post('/hotProductList/list', params)
}
// 捐赠板块
export const thank = (params) => {
  return request.post('/api/goods/thank', params)
}
// 获取验证码
export const geetest = (params) => {
  return request.post('/api/member/geetestInit', params)
}




// WEBPACK FOOTER //
// ./src/api/index.js